import * as yup from 'yup';

export const addAdminValidation = yup.object({
  fullName: yup.string().required('*required'),
  email: yup
    .string()
    .email('enter a valid email address')
    .required('*required'),
  phone: yup
    .string()
    .required('*required')
    .test(
      'Valid phone number',
      'number must start with +234 and must be valided nigerian number',
      (value) => /^\+234[0-9]{10}$/.test(value ?? '')
    )
});
